import moment from 'moment'
const notificationSound = new Audio('/static/sound/noti_sound.m4a')
export function notificationNewChatMessage({ users, timeInterval }) {
  const startTime = moment().subtract(timeInterval, 'ms')
  const currentTime = moment()
  const isAllowNotification = grantedNotification()
  if (isAllowNotification && !JSON.parse(localStorage.getItem('muteChat'))) {
    let newChatMessages = users.filter(user => {
      const isNew = moment(user.lastreply_time).isBetween(startTime, currentTime)
      return isNew ? user : null
    })

    newChatMessages = newChatMessages.slice(0, 4)
    newChatMessages.forEach(message => {
      const options = {
        body: `${message.first_name}: ${message.lastmessage}`,
        icon: '/static/img/logo-small-mobile.png'
      }
      const notification = new Notification('ZWIZ.AI Chatbot', options)
    })

    if (newChatMessages.length > 0) notificationSound.play()
  }
}

export async function grantedNotification() {
  let granted = false

  if (Notification.permission === 'granted') {
    granted = true
  } else if (Notification.permission !== 'denied') {
    let permission = await Notification.requestPermission()
    granted = permission === 'granted' ? true : false
  }
  return granted
}



// WEBPACK FOOTER //
// ./src/utils/notification.js